import Typography from "@mui/material/Typography";
import PageShell from "./PageShell";
import { pageStyles } from "./theme";

export default function SuccessPage({ title, children }) {
  return (
    <PageShell>
      <Typography component="h1" variant="h1" sx={pageStyles.title}>
        {title}
      </Typography>
      {children ? (
        <Typography variant="body1" sx={{ color: "#52667A", textAlign: "center" }}>
          {children}
        </Typography>
      ) : null}
    </PageShell>
  );
}
